// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"3e3d853a","682":"6c89b96d"}[chunkId] + ".chunk.css";
};